export default __webpack_public_path__ + "static/media/imc.43af89cd.svg";